import { SelfieStudioElement } from './selfie-studio';

if (!customElements.get('selfie-studio')) {
	customElements.define('selfie-studio', SelfieStudioElement);
}

export { SelfieStudioElement };
